// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cibgbrtongftvictzqwn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNpYmdicnRvbmdmdHZpY3R6cXduIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY4OTU2NTMsImV4cCI6MjA2MjQ3MTY1M30.xvqKZDsEBQSk3X6QpQTExcY1iym9dArXSjfA64nubsU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);